import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, NavLink, useLocation } from 'react-router-dom';
import StopsList from './components/StopsList';
import StopDetails from './components/StopDetails';
import MapView from './components/MapView';
import LinesList from './components/LinesList';
import TimetableView from './components/TimetableView';

import './App.css';

function AppContent({ darkMode, setDarkMode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isMapView = location.pathname === '/mapa' || location.pathname === '/mapa/';

  return (
    <div className={`app ${isMapView ? 'app--map' : 'app--page'}`}>
      {/* Hamburger button */}
      <button
        className="menu-button"
        onClick={() => setMenuOpen(true)}
        aria-label="Otwórz menu"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {/* Drawer overlay */}
      {menuOpen && (
        <div
          className="drawer-overlay"
          onClick={() => setMenuOpen(false)}
        />
      )}

      {/* Side drawer */}
      <aside className={`side-drawer ${menuOpen ? 'side-drawer--open' : ''}`}>
        <div className="drawer-header">
          <img
            src={process.env.PUBLIC_URL + '/logo.jpg'}
            alt="3City Live Logo"
            className="drawer-logo"
          />
          <div className="drawer-brand-text">
            <span className="drawer-brand">3City Live</span>
            <span className="drawer-brand-sub">ZTM Gdańsk · ZKM Gdynia</span>
          </div>
          <button
            className="drawer-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Zamknij menu"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <nav className="drawer-nav">
          <NavLink
            to="/mapa"
            className={({ isActive }) => `drawer-link ${isActive ? 'drawer-link--active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 7l6-3 6 3 6-3v13l-6 3-6-3-6 3V7z"/>
              <path d="M9 4v13M15 7v13"/>
            </svg>
            <span>Mapa</span>
          </NavLink>
          <NavLink
            to="/"
            end
            className={({ isActive }) => `drawer-link ${isActive ? 'drawer-link--active' : ''}`}
            onClick={() => setMenuOpen(false)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="4" y="4" width="7" height="7" rx="1"/>
              <rect x="13" y="4" width="7" height="7" rx="1"/>
              <rect x="4" y="13" width="7" height="7" rx="1"/>
              <rect x="13" y="13" width="7" height="7" rx="1"/>
            </svg>
            <span>Przystanki</span>
          </NavLink>
        </nav>

        <div className="drawer-footer">
          <button
            className="theme-toggle-row"
            onClick={() => setDarkMode(!darkMode)}
            aria-label={darkMode ? 'Przełącz na tryb jasny' : 'Przełącz na tryb ciemny'}
          >
            <span className="theme-toggle-icon">
              {darkMode ? (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="5"/>
                  <path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
                </svg>
              ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                </svg>
              )}
            </span>
            <span className="theme-toggle-label">{darkMode ? 'Tryb jasny' : 'Tryb ciemny'}</span>
            <div className={`theme-switch ${darkMode ? 'theme-switch--on' : ''}`}>
              <div className="theme-switch-thumb" />
            </div>
          </button>
        </div>
      </aside>

      {/* Content */}
      <Routes>
        <Route path="/" element={
          <main className="page-container">
            <StopsList />
          </main>
        } />
        <Route path="/stop/:stopId" element={
          <main className="page-container">
            <StopDetails />
          </main>
        } />
        <Route path="/rozklad" element={
          <main className="page-container">
            <LinesList />
          </main>
        } />
        <Route path="/rozklad/:routeId" element={
          <main className="page-container">
            <TimetableView />
          </main>
        } />
        <Route path="/mapa" element={<MapView />} />
      </Routes>
    </div>
  );
}

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('3citylive-dark') === 'true';
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    localStorage.setItem('3citylive-dark', darkMode);
  }, [darkMode]);

  return (
    <Router basename="/odjazdy">
      <AppContent darkMode={darkMode} setDarkMode={setDarkMode} />
    </Router>
  );
}

export default App;